import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class EWConfigurationService {
	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }
	loadDataEWConfiguration(periodId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/getEWConfig/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	addEWConfiguration(periodId, EWDescription, RouteDescription, routedate, finalSelectedDomiciles, _parameters) {
		const InData  = {
			periodId: Number(periodId),
			description: EWDescription,
			route: RouteDescription,
			routeDate: routedate,
			domicile: finalSelectedDomiciles,
			// parameters: parameters
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/gimanagement/addEWConfig`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	updateEWConfiguration(route, routedate, domicile, ewID, description) {
		const InData  = {
			route: route,
			routeDate: routedate,
			domicile: domicile,
			ewID: Number(ewID),
			description: description
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/gimanagement/updateEWConfig`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	copyEWConfiguration(fromPeriod, toPeriod) {

		return this.http.post(`${this.constantsService.baseAPIURL}/gimanagement/copyEWConfig/${fromPeriod}/${toPeriod}`, {}, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	deleteEWConfiguration(ewID): Observable<any> {
		return this.http
			.post(`${this.constantsService.baseAPIURL}/gimanagement/deleteEWConfig/${ewID}`, {}, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}


	getEWList(): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/getEWConfig/EWDesclist`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise()
	}

	getDomicileRouteList(): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/getEWConfig/domicilerouteList`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise()
	}



	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}

}